<div class="cases_page" [ngClass]="{'use_out': useOut}">
    <div class="container">
      <div class="filter_out" *ngIf="((useOut && initChats?.length > 3) || !useOut) && !is_mobile">  
        <form *ngIf="showFilter || useOut" [formGroup]="filter" class="filter_in" (ngSubmit)="filterChats(null, null, true)" >
          <div class="filter_form_in">
    
            <div class="d-f-c" #typeFilter>
              <mat-form-field appearance="legacy" class="filter_form search">
                <mat-icon matPrefix>search</mat-icon>
                <input formControlName="q" matInput>
                <mat-icon style="cursor: pointer;" (click)="openFilter(typeFilter, 'employee'); $event.preventDefault(); $event.stopPropagation();" matSuffix>tune</mat-icon>
              </mat-form-field>
              <button type="submit" class="filter_btn search_filter_btn">{{ "Search" | translate }}</button>
            </div>
    
            <mat-form-field appearance="legacy" class="filter_form type" *ngIf="!useOut">
              <mat-label>{{ "Status" | translate }}</mat-label>
              <mat-select [disableOptionCentering]="true" multiple selectDir formControlName="status_id"  (selectionChange)="selectChange($event)">
              <mat-option *ngFor="let status of statuses" [value]="status.id">
                  {{ status.name | translate }}
              </mat-option>
              </mat-select>
            </mat-form-field>
  
            <mat-form-field appearance="legacy" class="filter_form priority">
              <mat-label>{{ "Priority" | translate }}</mat-label>
              <mat-select [disableOptionCentering]="true" multiple selectDir formControlName="priority"  (selectionChange)="selectChange($event)">
                  <mat-option *ngFor="let priority of prioritys" [value]="priority.id">
                      {{ priority.name | translate }}
                  </mat-option>
              </mat-select>
            </mat-form-field>
    
          <mat-form-field appearance="legacy" class="filter_form group">
            <mat-label>{{ "Group" | translate }}</mat-label>
            <mat-select [disableOptionCentering]="true" selectDir formControlName="group_id" (selectionChange)="selectChange($event)">
                <mat-option>
                  <ngx-mat-select-search 
                      placeholderLabel="{{ 'Search' | translate }}" 
                      noEntriesFoundLabel="{{ 'no matching group found' | translate }}"
                      [formControl]="groupsControl"></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let group of groups$ | async" [value]="group.id">
                    {{ group.name | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        
        <div class="exec_filter_trigger" #parameterFilter (click)="openParameterFilter(parameterFilter, 'employee'); $event.preventDefault(); $event.stopPropagation();">
          {{ "Tag" | translate }}
        </div>
        
        <mat-form-field appearance="legacy" class="filter_form executor">
          <mat-label>{{ "Executor" | translate }}</mat-label>
          <mat-select [disableOptionCentering]="true" multiple selectDir formControlName="operation_employee_id"  (selectionChange)="selectChange($event)">
            <mat-option>
              <ngx-mat-select-search 
                  placeholderLabel="{{ 'Search' | translate }}" 
                  noEntriesFoundLabel="{{ 'no matching member found' | translate }}"
                  [formControl]="execControl"></ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="0">{{ "Not set" | translate }}</mat-option>
            <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
              <app-user [class]="'user_div'" [employee]="employee"></app-user>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="legacy" class="filter_form executor">
          <mat-label>{{ "Client" | translate }}</mat-label>
          <mat-select [disableOptionCentering]="true" multiple selectDir formControlName="client_employee_id"  (selectionChange)="selectChange($event)">
            <mat-option>
              <ngx-mat-select-search 
                  placeholderLabel="{{ 'Search' | translate }}" 
                  noEntriesFoundLabel="{{ 'no matching member found' | translate }}"
                  [formControl]="clientControl"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
              <app-user [class]="'user_div'" [employee]="employee"></app-user>
            </mat-option>
          </mat-select>
        </mat-form-field>
    
        <mat-form-field appearance="legacy" class="filter_form job" *ngIf="!useOut">
          <mat-label>{{ "Work" | translate }}</mat-label>
          <mat-select [disableOptionCentering]="true" multiple selectDir formControlName="task_operation_operation_id" (selectionChange)="selectChange($event)" >
            <mat-option *ngFor="let op of operationsValues" [value]="op.id">
                {{ op.name | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="exec_filter_trigger" style="border-right: 1px solid #EDEDED;" #chatDateFilter (click)="openDateFilter($event, chatDateFilter, 'employee'); $event.preventDefault(); $event.stopPropagation();">
          <mat-icon class="mr-1" style="opacity: .75;">calendar_month</mat-icon>
          {{ "Date" | translate }}
        </div>


          </div>
        </form>
        <div class="filter_values" *ngIf="filter">
          <ng-container *ngIf="!useOut; else elseTemplateChipsUseOut">
            <app-active-filters [section]="'Chats'" [company_id]="company_id" [filter]="filter" [filterValue]="filter.value" (RemoveValue)="removeValue($event)" (RemoveValueFromMultiple)="removeValueFromMultipleFil($event)"></app-active-filters>
          </ng-container>
          <ng-template #elseTemplateChipsUseOut>
            <mat-chip-list class="chips_wrp without_ordered start_page_chips">
              <mat-chip class="user_chip" (removed)="removeValue('channel_platform_id')" *ngIf="!!activatedRoute.snapshot.queryParamMap.get('channel_platform_id') || (!!activatedRoute.snapshot.queryParamMap.get('channel_platform_id') && activatedRoute.snapshot.queryParamMap.get('channel_platform_id').toString() == '0')">
                <div class="platform_wrp">
                  <div>
                    <app-platform [platform_id]="activatedRoute.snapshot.queryParamMap.get('channel_platform_id')"></app-platform>
                  </div>
                  {{ getPlatformById(activatedRoute.snapshot.queryParamMap.get('channel_platform_id'))?.name }}
                </div>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
  
              <ng-container *ngIf="filter.get('channel_id') && filter.get('channel_id').value && filter.get('channel_id').value.length">
                <span class="chip_out_label">{{ "Card Outlets" | translate }}</span>
                <mat-chip [ngClass]="{'user_chip': id != 0}" *ngFor="let id of filter.get('channel_id').value" (removed)="removeValueFromMultiple('channel_id', id)">
                  <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
                    <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
                  </ng-container>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
    
              <ng-container *ngIf="filter.get('no_channel_id') && filter.get('no_channel_id').value && filter.get('no_channel_id').value.length">
                <span class="chip_out_label">{{ "Not Presented" | translate }}</span>
                <mat-chip [ngClass]="{'user_chip': id != 0}" *ngFor="let id of filter.get('no_channel_id').value" (removed)="removeValueFromMultiple('no_channel_id', id)">
                  <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
                    <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
                  </ng-container>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
  
              <ng-container *ngIf="filter.get('discussion_channel_id') && filter.get('discussion_channel_id').value && filter.get('discussion_channel_id').value.length">
                <span class="chip_out_label">{{ "Chat Outlets" | translate }}</span>
                <mat-chip [ngClass]="{'user_chip': id != 0}" *ngFor="let id of filter.get('discussion_channel_id').value" (removed)="removeValueFromMultiple('discussion_channel_id', id)">
                  <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
                    <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
                  </ng-container>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
  
              <ng-template #elseTemplateOutletNotSet>
                {{ "Not Set" | translate}}
              </ng-template>
  
              <mat-chip (removed)="removeValue('q')" *ngIf="filter.get('q').value">
                {{filter.get('q').value}}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
  
              <mat-chip (removed)="removeValue('data_file_id')" *ngIf="filter.get('data_file_id').value !== ''">
                <ng-container *ngIf="filter.get('data_file_id').value === 'isset'">File Chats</ng-container>
                <ng-container *ngIf="filter.get('data_file_id').value === '0'">Just Chats</ng-container>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
  
              <mat-chip (removed)="removeValue('is_content_url')" *ngIf="filter.get('is_content_url').value || filter?.get('is_content_url').value == '0'">
                {{ contentUrl[filter.get('is_content_url').value].name }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
  
              <ng-container *ngIf="filter.get('group_id').value.length">
                <span class="chip_out_label">{{ "Group" | translate }}</span>
                <mat-chip *ngFor="let id of filter.get('group_id').value" (removed)="removeValueFromMultiple('group_id', id)">
                  <ng-container *ngIf="id === 0; else elseTemplateNoGroup">
                    {{ "Goup not set" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateNoGroup>
                    {{getGroup(id) ? getGroup(id)?.name : getPartnerGroup(id)?.name}}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('status_id').value && filter.get('status_id').value.length > 0">
                  <mat-chip [ngClass]="{'w8_chip': !!filter.get('discussion_other_employee_status_id').value}" (removed)="removeValue('status_id', val)" *ngFor="let val of filter.get('status_id').value">
                    {{getStatus(val)?.name | translate}}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
              </ng-container>
  
              <ng-container *ngIf="filter.get('priority').value && filter.get('priority').value.length > 0">
                  <mat-chip (removed)="removeValue('priority', val)" *ngFor="let val of filter.get('priority').value">
                    {{getPriority(val)?.name | translate}}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
              </ng-container>
  
              <mat-chip (removed)="removeValue('content_type_id')" *ngIf="filter.get('content_type_id').value || filter.get('content_type_id').value.toString() == '0'">
                <ng-container *ngIf="filter.get('content_type_id').value.toString() == '0'; else elseTemplateZeroContent">
                    {{ "Content Type" | translate }}: {{ "Not set" | translate }}
                </ng-container>
                <ng-template #elseTemplateZeroContent>
                </ng-template>
                {{ "Content Type" | translate }}: {{ getContentById(filter.get('content_type_id').value)?.name }}
             
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
  
              <ng-container *ngIf="filter.get('operation_employee_id').value && filter.get('operation_employee_id').value.length">
                  <ng-container *ngFor="let empl_id of filter.get('operation_employee_id').value">
                    <mat-chip [ngClass]="{'user_chip': empl_id != 0}" (removed)="removeValue('operation_employee_id', empl_id)" >
                      <span [ngClass]="{'mr-1': empl_id != 0}" style="font-weight: 500;">{{ "Executor" | translate }}</span>
                      <ng-container *ngIf="empl_id == 0; else elseTemplateNotSet">
                        <span style="margin-left: 3px;">
                          {{"Not Set"| translate }}
                        </span>
                      </ng-container>
                      <ng-template #elseTemplateNotSet>
                        <app-user [class]="'user_div'" [employee]="getEmployee(empl_id)"></app-user>
                      </ng-template>
                      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </ng-container>
              </ng-container>
  
              <ng-container *ngIf="filter.get('client_employee_id').value && filter.get('client_employee_id').value.length">
                  <ng-container *ngFor="let empl_id of filter.get('client_employee_id').value">
                    <mat-chip class="user_chip" (removed)="removeValue('client_employee_id', empl_id)" > 
                      <span class="mr-1" style="font-weight: 500;">{{ "Client" | translate }}</span>
                      <app-user [class]="'user_div'" [employee]="getEmployee(empl_id)"></app-user>
                      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </ng-container>
              </ng-container>
  
              <mat-chip class="user_chip" (removed)="removeValue('origin_company_id')" *ngIf="filter.get('origin_company_id').value">
                {{ "Partner Client" | translate }}:
                <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('origin_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
      
              <ng-container *ngIf="filter.get('task_operation_operation_id').value && filter.get('task_operation_operation_id').value.length">
                <span class="chip_out_label">{{ "Job type" | translate }}</span>
                <mat-chip *ngFor="let id of filter.get('task_operation_operation_id').value" (removed)="removeValueFromMultiple('task_operation_operation_id', id)">
                   {{ getColumnName(id) }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
  
              <ng-container *ngIf="filter.get('task_parameter_value_id').value.length">
                <span class="chip_out_label">{{ "Tag for task" | translate }}</span>
                <mat-chip *ngFor="let forTaskParamValueId of filter.get('task_parameter_value_id').value" (removed)="removeValueFromMultiple('task_parameter_value_id', forTaskParamValueId)">
                   {{ getValueById(forTaskParamValueId)?.value }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
    
              <ng-container *ngIf="filter.get('task_operation_parameter_value_id').value.length">
                <span class="chip_out_label">{{ "Tag for job" | translate }}</span>
                <mat-chip *ngFor="let forTaskParamValueId of filter.get('task_operation_parameter_value_id').value" (removed)="removeValueFromMultiple('task_operation_parameter_value_id', forTaskParamValueId)">
                   {{ getValueById(forTaskParamValueId)?.value }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
    
              <ng-container *ngIf="filter.get('discussion_parameter_value_id').value.length">
                <span class="chip_out_label">{{ "Tag for chat" | translate }}</span>
                <mat-chip *ngFor="let forTaskParamValueId of filter.get('discussion_parameter_value_id').value" (removed)="removeValueFromMultiple('discussion_parameter_value_id', forTaskParamValueId)">
                   {{ getValueById(forTaskParamValueId)?.value }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
    
              <ng-container *ngIf="filter.get('file_parameter_value_id').value.length">
                <span class="chip_out_label">{{ "Tag for file" | translate }}</span>
                <mat-chip *ngFor="let forTaskParamValueId of filter.get('file_parameter_value_id').value" (removed)="removeValueFromMultiple('file_parameter_value_id', forTaskParamValueId)">
                   {{ getValueById(forTaskParamValueId)?.value }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
    
              <ng-container *ngIf="filter.get('parameter_value_id').value.length">
                <span class="chip_out_label">{{ "Tag for everywhere" | translate }}</span>
                <mat-chip *ngFor="let forTaskParamValueId of filter.get('parameter_value_id').value" (removed)="removeValueFromMultiple('parameter_value_id', forTaskParamValueId)">
                   {{ getValueById(forTaskParamValueId)?.value }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
  
              <mat-chip (removed)="removeValue('q_name')" *ngIf="filter?.get('q_name')?.value">
                {{ "Chat title" | translate }}: {{ filter?.get('q_name')?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
  
              <mat-chip (removed)="removeValue('q_text')" *ngIf="filter?.get('q_text')?.value">
                {{ "Chat messages" | translate }}: {{ filter?.get('q_text')?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
              <mat-chip class="red_chip" (removed)="removeValue('no_operation_id')" *ngIf="filter.get('no_operation_id').value">
                {{ "Not assigned" | translate }}: {{ getColumnName(filter.get('no_operation_id').value) }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
  
            <!-- filter.get('posted_at_from').value || filter.get('posted_at_to').value || filter?.get('posted_at_to').value == '0' || filter.get('updated_at_from').value || filter.get('updated_at_to').value || filter?.get('updated_at_to').value == '0' || filter.get('created_at_from').value || filter.get('created_at_to').value || filter?.get('created_at_to').value == '0' || filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0' -->
            <ng-container *ngIf="filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0'">
              <span class="chip_out_label">{{ "Card Added" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('task_created_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('task_created_at_from')">
                  {{ filter?.get('task_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('task_created_at_to')">
                  <ng-container *ngIf="filter.get('task_created_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('task_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <ng-container *ngIf="filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0'">
              <span class="chip_out_label">{{ "Job added" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('task_operation_created_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('task_operation_created_at_from')">
                  {{ filter?.get('task_operation_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('task_operation_created_at_to')">
                  <ng-container *ngIf="filter.get('task_operation_created_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('task_operation_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <ng-container *ngIf="filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0'">
              <span class="chip_out_label">{{ "Job completed" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('task_operation_completed_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('task_operation_completed_at_from')">
                  {{ filter?.get('task_operation_completed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('task_operation_completed_at_to')">
                  <ng-container *ngIf="filter.get('task_operation_completed_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('task_operation_completed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <ng-container *ngIf="filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0'">
              <span class="chip_out_label">{{ "Chat added" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('discussion_created_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('discussion_created_at_from')">
                  {{ filter?.get('discussion_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('discussion_created_at_to')">
                  <ng-container *ngIf="filter.get('discussion_created_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('discussion_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <ng-container *ngIf="filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0'">
              <span class="chip_out_label">{{ "File added" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('file_created_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('file_created_at_from')">
                  {{ filter?.get('file_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('file_created_at_to')">
                  <ng-container *ngIf="filter.get('file_created_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('file_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <ng-container *ngIf="filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0'">
              <span class="chip_out_label">{{ "File updated" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('file_updated_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('file_updated_at_from')">
                  {{ filter?.get('file_updated_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('file_updated_at_to')">
                  <ng-container *ngIf="filter.get('file_updated_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('file_updated_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <ng-container *ngIf="filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0'">
              <span class="chip_out_label">{{ "File created" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('file_meta_creation_time_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('file_meta_creation_time_from')">
                  {{ filter?.get('file_meta_creation_time_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('file_meta_creation_time_to')">
                  <ng-container *ngIf="filter.get('file_meta_creation_time_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('file_meta_creation_time_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <ng-container *ngIf="filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0'">
              <span class="chip_out_label">{{ "Post published" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('task_channel_published_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('task_channel_published_at_from')">
                  {{ filter?.get('task_channel_published_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('task_channel_published_at_to')">
                  <ng-container *ngIf="filter.get('task_channel_published_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('task_channel_published_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <ng-container *ngIf="filter.get('created_at_from').value || filter.get('created_at_to').value || filter?.get('created_at_to').value == '0'">
              <span class="chip_out_label">{{ "Post created" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('created_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('created_at_from')">
                  {{ filter?.get('created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('created_at_to').value || filter?.get('created_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('created_at_to')">
                  <ng-container *ngIf="filter.get('created_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
  
            <ng-container *ngIf="filter.get('posted_at_from').value || filter.get('posted_at_to').value || filter?.get('posted_at_to').value == '0'">
              <span class="chip_out_label">{{ "Post added" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('posted_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('posted_at_from')">
                  {{ filter?.get('posted_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('posted_at_to').value || filter?.get('posted_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('posted_at_to')">
                  <ng-container *ngIf="filter.get('posted_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('posted_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <ng-container *ngIf="filter.get('discussion_completed_at_from').value || filter.get('discussion_completed_at_to').value || filter?.get('discussion_completed_at_to').value == '0'">
              <span class="chip_out_label">{{ "Chat Completed" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('discussion_completed_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('discussion_completed_at_from')">
                  {{ filter?.get('discussion_completed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('discussion_completed_at_to').value || filter?.get('discussion_completed_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('discussion_completed_at_to')">
                  <ng-container *ngIf="filter.get('discussion_completed_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('discussion_completed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
  
            <mat-chip (removed)="removeValue('task_custom_id')" *ngIf="filter?.get('task_custom_id')?.value">
              {{ "Card custom ID" | translate }}: {{ filter?.get('task_custom_id')?.value }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>
            
            <ng-container *ngIf="filter.get('discussion_planned_completed_at_from').value || filter.get('discussion_planned_completed_at_to').value || filter?.get('discussion_planned_completed_at_to').value == '0'">
              <span class="chip_out_label">{{ "Deadline" | translate }}</span>
  
              <div class="chip_splash"></div>
              
              <ng-container *ngIf="filter.get('discussion_planned_completed_at_from').value">
                <span class="small_chip_out_label">{{ "from" | translate}}</span>
                <mat-chip (removed)="removeValue('discussion_planned_completed_at_from')">
                  {{ filter?.get('discussion_planned_completed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
      
              <ng-container *ngIf="filter.get('discussion_planned_completed_at_to').value || filter?.get('discussion_planned_completed_at_to').value == '0'">
                <span class="small_chip_out_label">{{ "to" | translate}}</span>
                <mat-chip (removed)="removeValue('discussion_planned_completed_at_to')">
                  <ng-container *ngIf="filter.get('discussion_planned_completed_at_to').value == 0; else elseTemplateCompletedFilter">
                    {{ "Without date" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateCompletedFilter>
                    {{ filter?.get('discussion_planned_completed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </ng-container>
              
            <mat-icon class="remove_all_chips_btn" (click)="removeValue('all')" *ngIf="filter.get('q').value || filter.get('data_file_id').value !== '' || (filter.get('discussion_completed_at_from').value || filter.get('discussion_completed_at_to').value || filter?.get('discussion_completed_at_to').value == '0') || (filter.get('no_channel_id') && filter.get('no_channel_id').value && filter.get('no_channel_id').value.length) || filter.get('task_custom_id').value || (filter.get('content_type_id').value || filter.get('content_type_id').value.toString() == '0') || (filter.get('discussion_channel_id') && filter.get('discussion_channel_id').value && filter.get('discussion_channel_id').value.length) || (filter.get('channel_id') && filter.get('channel_id').value && filter.get('channel_id').value.length) || filter.get('no_operation_id').value || filter.get('origin_company_id').value || filter.get('discussion_planned_completed_at_from').value || filter.get('discussion_planned_completed_at_to').value || filter?.get('discussion_planned_completed_at_to').value == '0' || filter.get('posted_at_from').value || filter.get('posted_at_to').value || filter?.get('posted_at_to').value == '0' || filter.get('created_at_from').value || filter.get('created_at_to').value || filter?.get('created_at_to').value == '0' || filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0' || (filter.get('is_content_url').value || filter?.get('is_content_url').value == '0') || (filter.get('task_operation_operation_id').value && filter.get('task_operation_operation_id').value.length) || activatedRoute.snapshot.queryParamMap.get('channel_platform_id') || filter.get('task_parameter_value_id').value.length || filter.get('discussion_parameter_value_id').value.length || filter.get('task_operation_parameter_value_id').value.length || filter.get('parameter_value_id').value.length || filter.get('file_parameter_value_id').value.length || (filter.get('status_id').value && filter.get('status_id').value.length > 0) || (filter.get('priority').value && filter.get('priority').value.length > 0) || filter.get('group_id').value.length || (filter.get('operation_employee_id').value && filter.get('operation_employee_id').value.length) || (filter.get('client_employee_id').value && filter.get('client_employee_id').value.length) || filter?.get('q_name')?.value || filter?.get('q_text')?.value">cancel</mat-icon>
            </mat-chip-list>
          </ng-template>
          
  
          <div class="stats_wrp">
            <div class="tasks_counters">
              <button class="btn_w8 mr-1" type="button" (click)="togglePersonal()" *ngIf="!activeStatus.includes(0)">
                <mat-icon *ngIf="!filter.get('discussion_other_employee_status_id').value">check_box_outline_blank</mat-icon>
                <mat-icon *ngIf="!!filter.get('discussion_other_employee_status_id').value">check_box</mat-icon>
                {{"Only for personal statuses" | translate}}
              </button>
              <form [formGroup]="filter" class="preset_form" *ngIf="!useOut && bookmarks && bookmarks.length > 0">
                <div class="simple_filter_snippet" (click)="presetFilter.open()">
                  <ng-container *ngIf="filter.get('preset_id').value; else elseTemplatePreset">
                    <span class="name">
                      {{ getBookmarkById(filter.get('preset_id').value)?.name }}
                    </span>
                  </ng-container>
                  <ng-template #elseTemplatePreset>
                    <span class="name">
                      {{ "Preset" | translate }}
                    </span>
                  </ng-template>
                  

                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2474_38987)">
                    <path d="M7.91699 3.33325L2.08366 3.33325L5.00033 7.91658L7.91699 3.33325Z" fill="black"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_2474_38987">
                    <rect width="10" height="10" fill="white" transform="translate(10) rotate(90)"/>
                    </clipPath>
                    </defs>
                  </svg>
                </div>

                <mat-form-field appearance="legacy" class="filter_form preset_filter">
                  <mat-label>{{ "Preset" | translate }}</mat-label>
                  <mat-select #presetFilter [disableOptionCentering]="true" selectDir formControlName="preset_id" (selectionChange)="bookmarksChange($event)">
                      <mat-option *ngIf="bookmarks.length > 7">
                        <ngx-mat-select-search 
                            placeholderLabel="{{ 'Search' | translate }}" 
                            noEntriesFoundLabel="{{ 'no matching presets found' | translate }}"
                            [formControl]="bookmarksControl"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let bookmark of bookmarks$ | async" [value]="bookmark.id">
                        {{ bookmark.name | translate }}
                      </mat-option>
                  </mat-select>
                </mat-form-field>
              </form>
              <div class="counter_block" *ngIf="pagination && pagination['totalCount']">
                <div class="counter_top">{{ "Chats" | translate }}</div>
                <div class="counter_bottom">{{pagination['totalCount']}}</div>
                <!-- \{{chats.length}} -->
              </div>
              <button type="button" mat-icon-button (click)="refreshPage()" #tooltip="matTooltip"
              matTooltip="{{ 'Refresh results on the page' | translate }}"
              [matTooltipPosition]="'above'">
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="expands_wrp">
          <div class="d-f-c"></div>
          <div class="d-f-c">
              <div class="expand" [ngClass]="{'active': filter.get('origin_company_id').value == company_id}" (click)="setOrigCompany(company_id)">{{"This Workspace" | translate}}</div>
              <div class="expand" [ngClass]="{'active': filter.get('origin_company_id').value === 0}" (click)="setOrigCompany('0')">{{"This and partner workspaces" | translate}}</div>
          </div>
        </div>
      </div>
    
      <div class="lists_wrp" *ngIf="!is_mobile && (!useOut || (chats && chats.length))">
        <div class="lists_left">
          <div class="check_wrp">
            <mat-checkbox class="select_all_checkbox" *ngIf="chatCollection" (click)="$event.preventDefault; $event.stopPropagation()" (change)="$event ? masterToggle() : null"
              [checked]="chatCollection.hasValue() && isAllSelected()"
              [indeterminate]="chatCollection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </div>
          <!-- <div class="job_status_wrp">
            <ng-container *ngFor="let stat of statusesForFilter">
              <button *ngIf="stat.hasChats" mat-button (click)='changeActiveStatus(stat.id, $event)' [ngClass]="{'active_status': activeStatus.includes(stat.id)}">{{ stat.name | translate }}</button>
            </ng-container>
          </div> -->
          <div class="job_status_wrp" style="margin-left: 25px;" [ngClass]="{'active': activeStatus.includes(0)}">
            <button mat-button (click)='changeActiveStatus(0, $event)' [ngClass]="{'active_status': activeStatus.includes(0) || activeStatus.length == 0}">{{ "All" | translate }}</button>
          </div>
          <div class="job_status_wrp" *ngIf="statusesForFilter[1].hasChats || statusesForFilter[2].hasChats || statusesForFilter[5].hasChats" style="margin-left: 25px;" [ngClass]="{'active': activeStatus.length == 3 && activeStatus.includes(1) && activeStatus.includes(2) && activeStatus.includes(5)}">
            <button mat-button (click)='changeActiveStatus([1,2,5], $event)' [ngClass]="{'active_status': activeStatus.length == 3 && activeStatus.includes(1) && activeStatus.includes(2) && activeStatus.includes(5)}">{{ "All to do" | translate }}</button>
            <button mat-button *ngIf="(statusesForFilter[1].hasChats && !useOut) || (useOut && statusesForFilter[1].hasChats && (activeStatus.includes(1) || activeStatus.includes(2) || activeStatus.includes(5)))" (click)='changeActiveStatus(1, $event)' [ngClass]="{'active_status': activeStatus.includes(1) && activeStatus.length != 3}">{{ "Waiting" | translate }}</button>
            <button mat-button *ngIf="(statusesForFilter[2].hasChats && !useOut) || (useOut && statusesForFilter[2].hasChats && (activeStatus.includes(1) || activeStatus.includes(2) || activeStatus.includes(5)))" (click)='changeActiveStatus(2, $event)' [ngClass]="{'active_status': activeStatus.includes(2) && activeStatus.length != 3}">{{ "In process" | translate }}</button>
            <button mat-button *ngIf="(statusesForFilter[5].hasChats && !useOut) || (useOut && statusesForFilter[5].hasChats && (activeStatus.includes(1) || activeStatus.includes(2) || activeStatus.includes(5)))" (click)='changeActiveStatus(5, $event)' [ngClass]="{'active_status': activeStatus.includes(5) && activeStatus.length != 3}">{{ "To correct" | translate }}</button>
          </div>
    
          <div class="job_status_wrp" *ngIf="statusesForFilter[3].hasChats || statusesForFilter[4].hasChats || statusesForFilter[6].hasChats || statusesForFilter[7].hasChats || statusesForFilter[8].hasChats || statusesForFilter[9].hasChats" style="margin-left: 25px;" [ngClass]="{'active': activeStatus.length == 6 && activeStatus.includes(3) && activeStatus.includes(4) && activeStatus.includes(6) && activeStatus.includes(97) && activeStatus.includes(98) && activeStatus.includes(99)}">
            <button mat-button (click)='changeActiveStatus([3,4,6,97,98,99], $event)' [ngClass]="{'active_status': activeStatus.length == 6 && activeStatus.includes(3) && activeStatus.includes(4) && activeStatus.includes(6) && activeStatus.includes(97) && activeStatus.includes(98) && activeStatus.includes(99)}">{{ "All done" | translate }}</button>
            <button mat-button *ngIf="(statusesForFilter[3].hasChats && !useOut) || (useOut && statusesForFilter[3].hasChats && (activeStatus.includes(3) || activeStatus.includes(4) || activeStatus.includes(6) || activeStatus.includes(97) || activeStatus.includes(98) || activeStatus.includes(99)))" (click)='changeActiveStatus(3, $event)' [ngClass]="{'active_status': activeStatus.includes(3) && activeStatus.length != 6}">{{ "To approve" | translate }}</button>
            <button mat-button *ngIf="(statusesForFilter[4].hasChats && !useOut) || (useOut && statusesForFilter[4].hasChats && (activeStatus.includes(3) || activeStatus.includes(4) || activeStatus.includes(6) || activeStatus.includes(97) || activeStatus.includes(98) || activeStatus.includes(99)))" (click)='changeActiveStatus(4, $event)' [ngClass]="{'active_status': activeStatus.includes(4) && activeStatus.length != 6}">{{ "Approved" | translate }}</button>
            <button mat-button *ngIf="(statusesForFilter[6].hasChats && !useOut) || (useOut && statusesForFilter[6].hasChats && (activeStatus.includes(3) || activeStatus.includes(4) || activeStatus.includes(6) || activeStatus.includes(97) || activeStatus.includes(98) || activeStatus.includes(99)))" (click)='changeActiveStatus(6, $event)' [ngClass]="{'active_status': activeStatus.includes(6) && activeStatus.length != 6}">{{ "Sources needed" | translate }}</button>
            <button mat-button *ngIf="(statusesForFilter[7].hasChats && !useOut) || (useOut && statusesForFilter[7].hasChats && (activeStatus.includes(3) || activeStatus.includes(4) || activeStatus.includes(6) || activeStatus.includes(97) || activeStatus.includes(98) || activeStatus.includes(99)))" (click)='changeActiveStatus(97, $event)' [ngClass]="{'active_status': activeStatus.includes(97) && activeStatus.length != 6}">{{ "On hold" | translate }}</button>
            <button mat-button *ngIf="(statusesForFilter[8].hasChats && !useOut) || (useOut && statusesForFilter[8].hasChats && (activeStatus.includes(3) || activeStatus.includes(4) || activeStatus.includes(6) || activeStatus.includes(97) || activeStatus.includes(98) || activeStatus.includes(99)))" (click)='changeActiveStatus(98, $event)' [ngClass]="{'active_status': activeStatus.includes(98) && activeStatus.length != 6}">{{ "Ready" | translate }}</button>
            <button mat-button *ngIf="(statusesForFilter[9].hasChats && !useOut) || (useOut && statusesForFilter[9].hasChats && (activeStatus.includes(3) || activeStatus.includes(4) || activeStatus.includes(6) || activeStatus.includes(97) || activeStatus.includes(98) || activeStatus.includes(99)))" (click)='changeActiveStatus(99, $event)' [ngClass]="{'active_status': activeStatus.includes(99) && activeStatus.length != 6}">{{ "Canceled" | translate }}</button>
          </div>
        </div>
  
        <div class="d-f-c">
          <div class="task_collections_wrp" style="background: transparent;" *ngIf="chatCollection?.selected?.length && (company?.permissions?.includes('owner') || company?.permissions.includes('admin') || company?.permissions?.includes('manager'))">
            <div class="d-f-c">
              <span>{{ "Actions with" | translate }}</span>
              <span>{{ chatCollection?.selected?.length }}</span>
              <mat-icon style="transform: translateY(1px); color: #FF0000; margin-left: 5px; font-size: 12px; line-height: 12px; width: 12px; height: 12px;">chat_bubble</mat-icon>
            </div>
            <!-- <span>{{ "chats(s):" | translate }}</span> -->
        
            <div class="collections_btns">
              <button class="mint_btn ml-1" type="button" (click)="deleteChats()">
                  {{ "Delete chats" | translate }}
              </button>
              <button class="mint_btn ml-1" type="button" (click)="multiEditExecutors()">
                  {{ "Edit executors" | translate }}
              </button>
              <button class="mint_btn ml-1" type="button" (click)="multiEditJobsType()">
                  {{ "Edit jobs type" | translate }}
              </button>
            </div>
          </div>
          <mat-button-toggle-group class="view_group mr-1" *ngIf="fileChatsCount" (change)="changeViewChatTypes($event)" [value]="filter.get('data_file_id').value">
            <mat-button-toggle [value]="''">{{ "All" | translate }}</mat-button-toggle>
            <mat-button-toggle [value]="'isset'">{{ "File Chats" | translate }}</mat-button-toggle>
            <mat-button-toggle [value]="'0'">{{ "Just Chats" | translate }}</mat-button-toggle>
          </mat-button-toggle-group>

          <mat-button-toggle-group class="view_group" (change)="changeView($event)" [value]="filter.get('operation_employee_id').value && filter.get('operation_employee_id').value.includes(me?.id) ? 'executor' : 'client'">
            <mat-button-toggle value="client">{{ "As client" | translate }}</mat-button-toggle>
            <mat-button-toggle value="executor">{{ "As executor" | translate }}</mat-button-toggle>
          </mat-button-toggle-group>

          <div class="add_new_item_in_tab" (click)="createActiveChat()" *ngIf="!!useOut && company && company?.permissions?.includes('create_discussion')">
              + {{ "Add chat" | translate }}
          </div>
          
          <button type="button" mat-icon-button [matMenuTriggerFor]="sortBtn" class="mobActiveFilter" #tooltip="matTooltip" matTooltip="{{ 'Sort' | translate }}" [matTooltipPosition]="'above'">
            <mat-icon>sort</mat-icon>
          </button>
        </div>

        <mat-menu #sortBtn="matMenu" class="sort_tablet" xPosition='before' overlayPanelClass='sortTAB'>
          <div class="mat-menu-title">{{"Sort By" | translate}}:</div>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="sort(sortValue == 'updated_desc' ? 'updated' : 'updated_desc')" [ngClass]="{'active_status': sortValue == 'updated_desc' || sortValue == 'updated'}">
              {{  "Updated" | translate }}
              <div class="d-f-c ml-1">
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('updated_desc')" [ngClass]="{'active': sortValue == 'updated_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('updated')" [ngClass]="{'active': sortValue == 'updated'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
              </div>
          </button>
          <button mat-menu-item (click)="sort(sortValue == 'priority_desc' ? 'priority' : 'priority_desc')" [ngClass]="{'active_status': sortValue == 'priority_desc' || sortValue == 'priority'}">
              {{  "Priority" | translate }}
              <div class="d-f-c ml-1">
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('priority_desc')" [ngClass]="{'active': sortValue == 'priority_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('priority')" [ngClass]="{'active': sortValue == 'priority'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
              </div>
          </button>
          <button mat-menu-item (click)="sort(sortValue == 'id_desc' ? 'id' : 'id_desc')" [ngClass]="{'active_status': sortValue == 'id_desc' || sortValue == 'id'}">
              {{  "ID" | translate }}
              <div class="d-f-c ml-1">
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('id_desc')" [ngClass]="{'active': sortValue == 'id_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('id')" [ngClass]="{'active': sortValue == 'id'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
              </div>
          </button>
          <button mat-menu-item (click)="sort(sortValue == 'filesize_desc' ? 'filesize' : 'filesize_desc')" [ngClass]="{'active_status': sortValue == 'filesize_desc' || sortValue == 'filesize'}">
              {{ "Filesize" | translate }}
              <div class="d-f-c ml-1">
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('filesize_desc')" [ngClass]="{'active': sortValue == 'filesize_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('filesize')" [ngClass]="{'active': sortValue == 'filesize'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
              </div>
          </button>
          <button mat-menu-item (click)="sort(sortValue == 'planned_completed_desc' ? 'planned_completed' : 'planned_completed_desc')" [ngClass]="{'active_status': sortValue == 'planned_completed_desc' || sortValue == 'planned_completed'}">
              {{ "Deadline" | translate }}
              <div class="d-f-c ml-1">
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('planned_completed_desc')" [ngClass]="{'active': sortValue == 'planned_completed_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('planned_completed')" [ngClass]="{'active': sortValue == 'planned_completed'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
              </div>
          </button>
          <button mat-menu-item (click)="sort(sortValue == 'completed_desc' ? 'completed' : 'completed_desc')" [ngClass]="{'active_status': sortValue == 'completed_desc' || sortValue == 'completed'}">
              {{ "Completed" | translate }}
              <div class="d-f-c ml-1">
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('completed_desc')" [ngClass]="{'active': sortValue == 'completed_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                  <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('completed')" [ngClass]="{'active': sortValue == 'completed'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
              </div>
          </button>
        </mat-menu>
      </div>    
    </div>
    <div class="chats_wrp" #chatsContainer>

      <div class="d-f-c" style="justify-content: center; padding: 210px 0px;" *ngIf="!!useOut && company && company?.permissions?.includes('create_discussion') && (!!job.chatsInfo && !job.chatsInfo.length)">
        <div class="add_new_item_in_tab big_btn" (click)="createActiveChat()">
          + {{ "Add chat" | translate }}
        </div>
      </div>
      <ng-container *ngIf="!is_mobile; else elseTemplateDesctopSnippets">
        <div class="chats_out" *ngFor="let chat of chats; let cInd = index;" [ngClass]="{'highlight_chat': chat.is_read == '0'}">
          <div class="container chat" (contextmenu)="openChatMenu($event, chat); $event.preventDefault(); $event.stopPropagation();" *ngIf="!useOut || jobHasChat(job.chatsInfo, chat.id)" (click)="useOut ? goToChat(chat) : openChat($event, chat, cInd)" [ngClass]="{'no_p_stat': chat?.employees?.length > chat?.employeesStatuses?.length}">
              <div class="priority_line" [ngClass]="{
                  'useOut': useOut,
                  'Urgent': chat?.priority == '1000',
                  'High': chat?.priority == '900',
                  'Middle': chat?.priority == '800',
                  'Low': chat?.priority == '700',
                  'No': chat?.priority == '0' || !chat?.priority
              }"></div>
              <div class="chat_btns" [ngClass]="{'useOut': useOut, 'show_checked': chatCollection && chatCollection.isSelected(chat)}">
                <button mat-icon-button ngxClipboard [cbContent]="origin + '/chat/' + chat.acm" (click)="$event.stopPropagation(); copyLink('Chat')">
                  <mat-icon>insert_link</mat-icon>
                </button>
                <button mat-icon-button [matMenuTriggerFor]="menuChat" (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menuChat="matMenu">
                  <!-- <button mat-menu-item (click)="editChatStatus(chat, 1)">
                      <mat-icon>edit</mat-icon> 
                      <span>{{ "To - Waiting" | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="editChatStatus(chat, 4)">
                      <mat-icon>edit</mat-icon> 
                      <span>{{ "To - To approve" | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="editChatStatus(chat, false)">
                      <mat-icon>edit</mat-icon> 
                      <span>{{ "To - Random" | translate }}</span>
                  </button> -->
                  <button mat-menu-item (click)="openNotes(chat)">
                    <mat-icon>text_snippet</mat-icon>
                    <span>{{ 'Notes' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="editChat(chat)">
                      <mat-icon>edit</mat-icon> 
                      <span>{{ "Edit" | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="toShortCut($event, chat, 'chat')">
                    <div class="d-f-c">
                      <svg width="18" style="margin-right: 16px;" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 0L5.778 5.004L0 6.516L3.78 11.142L3.438 17.1L9 14.931L14.562 17.1L14.22 11.142L18 6.516L12.222 5.004L9 0ZM6.642 7.2C7.2 7.2 7.65 7.65 7.65 8.217C7.65 8.48434 7.5438 8.74073 7.35476 8.92976C7.16573 9.1188 6.90934 9.225 6.642 9.225C6.075 9.225 5.625 8.775 5.625 8.217C5.625 7.65 6.075 7.2 6.642 7.2ZM11.367 7.2C11.925 7.2 12.375 7.65 12.375 8.217C12.375 8.48434 12.2688 8.74073 12.0798 8.92976C11.8907 9.1188 11.6343 9.225 11.367 9.225C10.8 9.225 10.35 8.775 10.35 8.217C10.35 7.65 10.8 7.2 11.367 7.2ZM6.3 11.25H11.7C11.25 12.339 10.179 13.05 9 13.05C7.821 13.05 6.75 12.339 6.3 11.25Z" fill="#686868"/>
                      </svg>
                      <span>{{ "Shortcut" | translate }}</span>
                    </div>
                  </button>
                  <button mat-menu-item (click)="addToBoard(chat)">
                      <mat-icon>add</mat-icon> 
                      <span>{{ "Add chat to planning board" | translate }}</span>
                  </button>
                  <!-- <ng-container *ngIf="company?.permissions.includes('owner')">
                      <button mat-menu-item (click)="additionalEmployees(task, work, chat)">
                        <mat-icon>group</mat-icon> 
                        <span>{{ "Additional executor" | translate }}</span>
                      </button>
                      <button mat-menu-item (click)="addAdditionalEmplToWork(task, work, chat)">
                        <mat-icon>person_add</mat-icon> 
                        <span>{{ "Appoint an additional executor" | translate }}</span>
                      </button>
                  </ng-container> -->
                  <ng-container *ngIf="company?.permissions.includes('owner') || company?.permissions?.includes('admin'); else elseTemplateOwnerDel">
                      <button mat-menu-item (click)="deleteChat(chat)">
                          <mat-icon>delete</mat-icon>
                          <span>{{ "Delete" | translate }}</span>
                      </button>
                  </ng-container>
                  <ng-template #elseTemplateOwnerDel>
                      <div
                      matTooltip="{{ 'You do not have access for this action.' | translate }}"
                      [matTooltipPosition]="'left'">
                          <button mat-menu-item disabled>
                              <mat-icon>delete</mat-icon>
                              <span>{{ "Delete" | translate }}</span>
                          </button>
                      </div>
                  </ng-template>
                  <button *ngIf="(company?.permissions.includes('owner') || company?.permissions.includes('manager')) && chat?.company_id == company.id" mat-menu-item (click)="moveChat(chat)">
                    <mat-icon style="transform: rotate(45deg);">zoom_out_map</mat-icon> 
                    <span>{{ "Move chat to other job" | translate }}</span>
                  </button>
                  <button *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin') || company?.permissions.includes('manager') || company?.permissions.includes('assign_task_parameter')" mat-menu-item (click)="openTargetValues([chat.task_id, chat.task_operation_id, chat.id], chat)">
                    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 18px; height: 15px;"><path d="M3.15 4.5C3.50804 4.5 3.85142 4.35777 4.10459 4.10459C4.35777 3.85142 4.5 3.50804 4.5 3.15C4.5 2.79196 4.35777 2.44858 4.10459 2.19541C3.85142 1.94223 3.50804 1.8 3.15 1.8C2.79196 1.8 2.44858 1.94223 2.19541 2.19541C1.94223 2.44858 1.8 2.79196 1.8 3.15C1.8 3.50804 1.94223 3.85142 2.19541 4.10459C2.44858 4.35777 2.79196 4.5 3.15 4.5ZM13.869 6.822C14.193 7.146 14.4 7.596 14.4 8.1C14.4 8.595 14.202 9.045 13.869 9.369L9.369 13.869C9.045 14.193 8.595 14.4 8.1 14.4C7.605 14.4 7.155 14.202 6.822 13.869L0.531 7.578C0.198 7.245 0 6.795 0 6.3V1.8C0 0.801 0.801 0 1.8 0H6.3C6.795 0 7.245 0.198 7.569 0.522L13.869 6.822ZM10.386 1.539L11.286 0.639L17.469 6.822C17.802 7.146 18 7.605 18 8.1C18 8.595 17.802 9.045 17.478 9.369L12.636 14.211L11.736 13.311L16.875 8.1L10.386 1.539Z" fill="#686868"></path></svg>
                    <span>{{ "Tags" | translate }}</span>
                  </button>
                </mat-menu>
                <div class="check_wrp">
                  <mat-checkbox color="primary" class="example-margin" (click)="clickOnCheck($event, chat, cInd); $event.stopPropagation()" (change)="$event ? toggleChat(chat) : null" [checked]='chatCollection && chatCollection.isSelected(chat)'></mat-checkbox>
                </div>
              </div>
              <div class="chat_creator" *ngIf="!useOut">
                  <div class="chat_user" *ngIf="!!chat?.employee">
                      <ng-container *ngIf="!!chat?.employee?.image; else elseOwnerTemplate">
                        <img [appHoverUserInfo]="{ user: chat?.employee, company_id: company?.id }" [src]="chat?.employee?.image" alt="">
                      </ng-container>
                      <ng-template #elseOwnerTemplate>
                          <mat-icon [appHoverUserInfo]="{ user: chat?.employee, company_id: company?.id }">account_circle</mat-icon>
                      </ng-template>
                      <div class="created_info">
                          <div class="text_one_line">{{chat?.employee?.name}}</div>
                          <div
                          matTooltip="{{ chat?.created_at*1000 | date:'h:mm a':'timeZone':activeLang }} "
                          [matTooltipPosition]="'left'">
                              {{ chat?.created_at*1000 | date:'MMM d, y':'timeZone':activeLang | yearPipe }} 
                          </div>
                      </div>
                  </div>
              </div>
              <div class="chat_status">
                <div style="width: 100%">
                  <div class="inside_job" [ngClass]="{
                      'first': chat?.status_id == '1',
                      'second': chat?.status_id == '2',
                      'third': chat?.status_id == '3',
                      'fours': chat?.status_id == '4',
                      'fives': chat?.status_id == '5',
                      'sixs': chat?.status_id == '6',
                      'nine': chat?.status_id == '97',
                      'seven': chat?.status_id == '98',
                      'eight': chat?.status_id == '99'}">
                      <span class="text_one_line">{{ getOperationStatusName(chat?.status_id) | translate }}</span>  
                  </div>
                  <div class="chat_cr" *ngIf="useOut">
                    <div class="chat_cr_avatar" 
                    #tooltip="matTooltip" 
                    matTooltip="{{chat?.employee?.name}}"
                    [matTooltipPosition]="'above'">
                      <ng-container *ngIf="!!chat?.employee?.image; else elseOwnerTemplate">
                        <img [appHoverUserInfo]="{ user: chat?.employee, company_id: company?.id }" [src]="chat?.employee?.image" alt="">
                      </ng-container>
                      <ng-template #elseOwnerTemplate>
                          <mat-icon [appHoverUserInfo]="{ user: chat?.employee, company_id: company?.id }">account_circle</mat-icon>
                      </ng-template>
                    </div>
                    <div class="chat_cr_date fl"
                    matTooltip="{{ chat?.created_at*1000 | date:'h:mm a':'timeZone':activeLang }} "
                    [matTooltipPosition]="'above'">
                        {{ chat?.created_at*1000 | date:'MMM d, y':'timeZone':activeLang | yearPipe }} 
                    </div>
                  </div>
                </div>
              </div>
              <div class="chat_data">
                  <div class="chat_name text_one_line">
                      {{ chat?.name }}
                  </div>

                  
                  <ng-container *ngIf="chat?.lastPost?.action; else elseTemplateHasAction">
                    <div class="chat_last_post">

                      <ng-container *ngIf="!!chat?.lastPost?.action?.createdEmployee?.image; else elseOwnerTemplateLastPost">
                          <img [appHoverUserInfo]="{ user: chat?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5" [src]="chat?.lastPost?.action?.createdEmployee?.image" alt="">
                      </ng-container>
                      <ng-template #elseOwnerTemplateLastPost>
                          <mat-icon [appHoverUserInfo]="{ user: chat?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5">account_circle</mat-icon>
                      </ng-template>

                      {{ 'switched to' | translate }} 
                      <ng-container [ngSwitch]="chat?.lastPost?.action?.action">
                        <ng-container *ngSwitchCase="'task_employee_status_change'">
                          <b style="margin-left: 5px; margin-right: 5px;">{{ getChatStatus(chat?.lastPost?.action?.task_employee_status_id) }}</b>
                          {{ "for" | translate }}
                          <ng-container *ngIf="!!chat?.lastPost?.action?.employee?.image; else elseActionOwnerTemplate">
                              <img [appHoverUserInfo]="{ user: chat?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5" [src]="chat?.lastPost?.action?.employee?.image" alt="">
                          </ng-container>
                          <ng-template #elseActionOwnerTemplate>
                              <mat-icon [appHoverUserInfo]="{ user: chat?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5">account_circle</mat-icon>
                          </ng-template>
                        </ng-container>
                        <ng-container *ngSwitchCase="'discussion_status'">
                            <b style="margin-left: 5px;">{{ getChatStatus(chat?.lastPost?.action?.discussion_status_id) }}</b>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-template #elseTemplateHasAction>
                    <div class="chat_last_post">
                      <ng-container *ngIf="!!chat?.lastPost?.employee?.image; else elseOwnerTemplateLastPost">
                          <img [appHoverUserInfo]="{ user: chat?.lastPost?.employee, company_id: company?.id }" [src]="chat?.lastPost?.employee?.image" alt="">
                      </ng-container>
                      <ng-template #elseOwnerTemplateLastPost>
                          <mat-icon [appHoverUserInfo]="{ user: chat?.lastPost?.employee, company_id: company?.id }">account_circle</mat-icon>
                      </ng-template>
                      
                      <div class="last_post_file" *ngIf="!!chat?.lastPost?.file_id">
                        <div class="file_view">
                          <ng-container [ngSwitch]="understandFileType(chat?.lastPost?.file?.content_type)">
                              <ng-container *ngSwitchCase="'video'">
                                  <div class="file movie d-f-c">
                                      <ng-container *ngIf="chat?.lastPost?.file?.thumbnail; else elseTemplateThumbnail">
                                          <div class="movie_thumb" >
                                              <img style="max-width: 100%; max-height: 100%;" (error)="onImgError($event)" [src]="host + chat?.lastPost?.file?.thumbnail + '?company_id=' + company?.id">
                                          </div>
                                      </ng-container>
                                      <ng-template #elseTemplateThumbnail>
                                          <mat-icon class="file_img_icon" style="color: #3f51b5">
                                              movie
                                          </mat-icon>
                                      </ng-template>
                                  </div>
                              </ng-container>
                              <ng-container *ngSwitchCase="'pdf'">
                                <div class="pdf">
                                    <svg height="800px" width="800px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                        viewBox="0 0 303.188 303.188" xml:space="preserve">
                                        <g>
                                            <polygon style="fill:#E8E8E8;" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 	"/>
                                            <path style="fill:#FB3449;" d="M230.013,149.935c-3.643-6.493-16.231-8.533-22.006-9.451c-4.552-0.724-9.199-0.94-13.803-0.936
                                                c-3.615-0.024-7.177,0.154-10.693,0.354c-1.296,0.087-2.579,0.199-3.861,0.31c-1.314-1.36-2.584-2.765-3.813-4.202
                                                c-7.82-9.257-14.134-19.755-19.279-30.664c1.366-5.271,2.459-10.772,3.119-16.485c1.205-10.427,1.619-22.31-2.288-32.251
                                                c-1.349-3.431-4.946-7.608-9.096-5.528c-4.771,2.392-6.113,9.169-6.502,13.973c-0.313,3.883-0.094,7.776,0.558,11.594
                                                c0.664,3.844,1.733,7.494,2.897,11.139c1.086,3.342,2.283,6.658,3.588,9.943c-0.828,2.586-1.707,5.127-2.63,7.603
                                                c-2.152,5.643-4.479,11.004-6.717,16.161c-1.18,2.557-2.335,5.06-3.465,7.507c-3.576,7.855-7.458,15.566-11.815,23.02
                                                c-10.163,3.585-19.283,7.741-26.857,12.625c-4.063,2.625-7.652,5.476-10.641,8.603c-2.822,2.952-5.69,6.783-5.941,11.024
                                                c-0.141,2.394,0.807,4.717,2.768,6.137c2.697,2.015,6.271,1.881,9.4,1.225c10.25-2.15,18.121-10.961,24.824-18.387
                                                c4.617-5.115,9.872-11.61,15.369-19.465c0.012-0.018,0.024-0.036,0.037-0.054c9.428-2.923,19.689-5.391,30.579-7.205
                                                c4.975-0.825,10.082-1.5,15.291-1.974c3.663,3.431,7.621,6.555,11.939,9.164c3.363,2.069,6.94,3.816,10.684,5.119
                                                c3.786,1.237,7.595,2.247,11.528,2.886c1.986,0.284,4.017,0.413,6.092,0.335c4.631-0.175,11.278-1.951,11.714-7.57
                                                C231.127,152.765,230.756,151.257,230.013,149.935z M119.144,160.245c-2.169,3.36-4.261,6.382-6.232,9.041
                                                c-4.827,6.568-10.34,14.369-18.322,17.286c-1.516,0.554-3.512,1.126-5.616,1.002c-1.874-0.11-3.722-0.937-3.637-3.065
                                                c0.042-1.114,0.587-2.535,1.423-3.931c0.915-1.531,2.048-2.935,3.275-4.226c2.629-2.762,5.953-5.439,9.777-7.918
                                                c5.865-3.805,12.867-7.23,20.672-10.286C120.035,158.858,119.587,159.564,119.144,160.245z M146.366,75.985
                                                c-0.602-3.514-0.693-7.077-0.323-10.503c0.184-1.713,0.533-3.385,1.038-4.952c0.428-1.33,1.352-4.576,2.826-4.993
                                                c2.43-0.688,3.177,4.529,3.452,6.005c1.566,8.396,0.186,17.733-1.693,25.969c-0.299,1.31-0.632,2.599-0.973,3.883
                                                c-0.582-1.601-1.137-3.207-1.648-4.821C147.945,83.048,146.939,79.482,146.366,75.985z M163.049,142.265
                                                c-9.13,1.48-17.815,3.419-25.979,5.708c0.983-0.275,5.475-8.788,6.477-10.555c4.721-8.315,8.583-17.042,11.358-26.197
                                                c4.9,9.691,10.847,18.962,18.153,27.214c0.673,0.749,1.357,1.489,2.053,2.22C171.017,141.096,166.988,141.633,163.049,142.265z
                                                M224.793,153.959c-0.334,1.805-4.189,2.837-5.988,3.121c-5.316,0.836-10.94,0.167-16.028-1.542
                                                c-3.491-1.172-6.858-2.768-10.057-4.688c-3.18-1.921-6.155-4.181-8.936-6.673c3.429-0.206,6.9-0.341,10.388-0.275
                                                c3.488,0.035,7.003,0.211,10.475,0.664c6.511,0.726,13.807,2.961,18.932,7.186C224.588,152.585,224.91,153.321,224.793,153.959z"/>
                                            <polygon style="fill:#FB3449;" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0 	"/>
                                            <g>
                                                <path style="fill:#A4A9AD;" d="M126.841,241.152c0,5.361-1.58,9.501-4.742,12.421c-3.162,2.921-7.652,4.381-13.472,4.381h-3.643
                                                    v15.917H92.022v-47.979h16.606c6.06,0,10.611,1.324,13.652,3.971C125.321,232.51,126.841,236.273,126.841,241.152z
                                                    M104.985,247.387h2.363c1.947,0,3.495-0.546,4.644-1.641c1.149-1.094,1.723-2.604,1.723-4.529c0-3.238-1.794-4.857-5.382-4.857
                                                    h-3.348C104.985,236.36,104.985,247.387,104.985,247.387z"/>
                                                <path style="fill:#A4A9AD;" d="M175.215,248.864c0,8.007-2.205,14.177-6.613,18.509s-10.606,6.498-18.591,6.498h-15.523v-47.979
                                                    h16.606c7.701,0,13.646,1.969,17.836,5.907C173.119,235.737,175.215,241.426,175.215,248.864z M161.76,249.324
                                                    c0-4.398-0.87-7.657-2.609-9.78c-1.739-2.122-4.381-3.183-7.926-3.183h-3.773v26.877h2.888c3.939,0,6.826-1.143,8.664-3.43
                                                    C160.841,257.523,161.76,254.028,161.76,249.324z"/>
                                                <path style="fill:#A4A9AD;" d="M196.579,273.871h-12.766v-47.979h28.355v10.403h-15.589v9.156h14.374v10.403h-14.374
                                                    L196.579,273.871L196.579,273.871z"/>
                                            </g>
                                            <polygon style="fill:#D1D3D3;" points="219.821,50.525 270.346,50.525 219.821,0 	"/>
                                        </g>
                                    </svg>
                                </div>
                            </ng-container>
                              <ng-container *ngSwitchCase="'image'">
                                  <div class="img_wrp">
                                      <img (error)="onImgError($event)" [src]="host + (chat?.lastPost?.file?.thumbnail ? chat?.lastPost?.file?.thumbnail + '?company_id=' + company?.id : chat?.lastPost?.file?.original + '?company_id=' + company?.id)" alt="">
                                  </div>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <ng-container *ngIf="!!chat?.lastPost?.file?.thumbnail; else elseTemplateHasThumb">
                                  <div class="img_wrp">
                                    <img (error)="onImgError($event)" [src]="host + chat?.lastPost?.file?.thumbnail + '?company_id=' + company?.id" alt="">
                                  </div>
                                </ng-container>
                                <ng-template #elseTemplateHasThumb>
                                  <div class="file d-f-c">
                                    <mat-icon class="file_img_icon mr-1" style="color: #3f51b5">
                                        insert_drive_file
                                    </mat-icon>
                                </div>
                                </ng-template>
                              </ng-container>
                          </ng-container>
                        </div>
                        <!-- <div class="file_info">
                            <span class="file_name">{{ chat?.lastPost?.file?.filename }}</span>
                            <span class="file_size">{{ chat?.lastPost?.file?.filesize | filesize }}</span>
                        </div> -->

                      </div>
                      <div class="text_one_line" [innerHTML]='chat?.lastPost?.text ? (chat?.lastPost?.text.replaceAll("\n"," ").replaceAll("</BR>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("<br>"," ")) : ""'></div>
                      <!-- <div class="text_one_line" [innerHTML]='chat?.lastPost?.text ? (chat?.lastPost?.text) : ""'></div> -->
                  </div>
                  </ng-template>
                 
              </div>
              <div class="connections_info">
                  <div class="job_desc text_one_line" *ngIf="chat?.taskOperation?.name">
                      {{ chat?.taskOperation?.name }}
                  </div>
                  <div class="job_type">
                      {{ getColumnName(chat?.taskOperation?.operation_id) }}
                  </div>
                  <div class="task text_one_line">
                      {{ chat?.task?.name }}
                  </div>
                  <div class="group" *ngIf="chat?.task?.group_id">
                      {{ getGroup(chat?.task?.group_id).name }}
                  </div>
              </div>
              <div class="chat_employees">
                  
                  <div class="block_inside" *ngIf="chat?.employees?.length > 0">
                      <ng-container *ngFor="let employee of chat?.employees; let i = index;">
                          <div class="chat_empl" *ngIf="i < 3"  #tooltip="matTooltip" 
                          [ngClass]="{
                            'first': employee?.employeeStatus?.status_id == '1',
                            'second': employee?.employeeStatus?.status_id == '2',
                            'third': employee?.employeeStatus?.status_id == '3',
                            'fours': employee?.employeeStatus?.status_id == '4',
                            'fives': employee?.employeeStatus?.status_id == '5',
                            'sixs': employee?.employeeStatus?.status_id == '6',
                            'nine': employee?.employeeStatus?.status_id == '97',
                            'seven': employee?.employeeStatus?.status_id == '98',
                            'eight': employee?.employeeStatus?.status_id == '99'}"
                          matTooltip="{{employee?.employee?.name}}"
                          [matTooltipPosition]="'below'" [ngStyle]="{'z-index': chat?.employees?.length - i, 'transform': 'translateX(-' + i*6 + 'px)'}">
                            <ng-container *ngIf="employee?.employee?.image; else elseMobWorkTemplate">
                              <img [appHoverUserInfo]="{ user: employee?.employee, company_id: company?.id }" [src]="employee?.employee?.image" alt="">
                            </ng-container>
                            <ng-template #elseMobWorkTemplate>
                              <mat-icon [appHoverUserInfo]="{ user: employee?.employee, company_id: company?.id }">account_circle</mat-icon>
                            </ng-template>

                            <div class="calendar" #tooltip="matTooltip"
                            matTooltip="{{employee?.employeeStatus?.start_at*1000 | date:'MMM dd. Y':'+0000':activeLang | yearPipe}}"
                            [matTooltipPosition]="'right'"
                            *ngIf="!!employee?.employeeStatus && !!employee?.employeeStatus?.discussion_id && [1,2,5].includes(employee?.employeeStatus?.status_id) && employee?.employeeStatus.start_at > 0">
                              <svg [ngClass]="{'red': employee?.employeeStatus.initial_start_at < today}" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.90909 0V1.27273H1.27273C0.566364 1.27273 0 1.83909 0 2.54545V11.4545C0 12.1545 0.566364 12.7273 1.27273 12.7273H5.15455C5.95636 13.5164 7.05727 14 8.27273 14C10.7355 14 12.7273 12.0082 12.7273 9.54545C12.7273 8.33 12.2436 7.22909 11.4545 6.42727V2.54545C11.4545 1.84545 10.8882 1.27273 10.1818 1.27273H9.54545V0H8.27273V1.27273H3.18182V0H1.90909ZM1.27273 2.54545H10.1818V3.81818H1.27273V2.54545ZM1.27273 5.09091H10.1818V5.51727C9.60273 5.24364 8.95364 5.09091 8.27273 5.09091C5.81 5.09091 3.81818 7.08273 3.81818 9.54545C3.81818 10.2264 3.97091 10.8755 4.24455 11.4545H1.27273V5.09091ZM8.27273 6.45909C9.97818 6.45909 11.3591 7.84 11.3591 9.54545C11.3591 11.2509 9.97818 12.6318 8.27273 12.6318C6.56727 12.6318 5.18636 11.2509 5.18636 9.54545C5.18636 7.84 6.56727 6.45909 8.27273 6.45909ZM7.63636 7.63636V9.98455L9.66636 11.1555L10.1436 10.3282L8.59091 9.43091V7.63636H7.63636Z" fill="#219653"/>
                              </svg>
                            </div>

                          </div>
                          <ng-container *ngIf="i >= 3 && i == chat?.employees?.length - 1">
                              <div class="more_empl" [ngStyle]="{'z-index': chat?.employees?.length - 3, 'transform': 'translateX(-' + 2*6 + 'px)'}">
                                  +{{chat?.employees?.length - 3}}
                              </div>
                          </ng-container>
                      </ng-container>
                  </div>
              </div>
              <ng-container *ngIf="chat.updated_at > today; else updatedAtTempl">
                <div class="chat_updated_at time" #tooltip="matTooltip"
                matTooltip="{{ chat.updated_at*1000 | date:'MMM d, y':'timeZone':activeLang | yearPipe }}"
                [matTooltipPosition]="'left'">
                  {{ chat.updated_at*1000 | date:'hh:mm a':'timeZone':activeLang | yearPipe }}
                </div>
              </ng-container>
              <ng-template #updatedAtTempl>
                <div class="chat_updated_at" #tooltip="matTooltip"
                matTooltip="{{ chat.updated_at*1000 | date:'hh:mm a':'timeZone':activeLang | yearPipe }}"
                [matTooltipPosition]="'left'">
                  {{ chat.updated_at*1000 | date:'MMM d, y':'timeZone':activeLang | yearPipe }}
                </div>
              </ng-template>

              <div class="chat_btns_right">
                <div class="chat_con_btn" (click)="$event.preventDefault(); $event.stopPropagation(); openConnectionChats(chat)">
                  <svg style="cursor: pointer;" class="chat_cons" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z" fill="#D7D7D7"/>
                    <circle *ngIf="chat?.partOfDiscussionPartition?.length != 0" cx="6" cy="12" r="3" fill="#96A6C2"/>
                    <circle *ngIf="chat?.discussionRelated?.length != 0" cx="18" cy="19" r="3" fill="#FFD0A7"/>
                    <circle *ngIf="chat?.consistOfDiscussionPartition?.length != 0" cx="18" cy="5" r="3" fill="#98F1BD"/>
                  </svg>
                </div>
                <div class="to_board_btn" (click)="$event.preventDefault(); $event.stopPropagation(); addToBoard(chat)">
                  <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.8 12L6 16.8H9.6V24H12V16.8H15.6L10.8 12ZM19.2 2.4H18V0H15.6V2.4H6V0H3.6V2.4H2.4C1.76348 2.4 1.15303 2.65286 0.702944 3.10294C0.252856 3.55303 0 4.16348 0 4.8V21.6C0 22.2365 0.252856 22.847 0.702944 23.2971C1.15303 23.7471 1.76348 24 2.4 24H7.2V21.6H2.4V8.4H19.2V21.6H14.4V24H19.2C19.8365 24 20.447 23.7471 20.8971 23.2971C21.3471 22.847 21.6 22.2365 21.6 21.6V4.8C21.6 4.16348 21.3471 3.55303 20.8971 3.10294C20.447 2.65286 19.8365 2.4 19.2 2.4Z" fill="#219653"/>
                  </svg>
                </div>
              </div>
                
              
           
              <div class="is_pin">
                  <svg *ngIf="!!chat.data" matTooltip="{{ 'Chat connected to the file. Open chat to see this file.' | translate }}" [matTooltipPosition]="'left'" class="chat_have_file" style="width: 5.5px; height: 11px; " width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.25 3V8.75C5.25 9.855 4.355 10.75 3.25 10.75C2.145 10.75 1.25 9.855 1.25 8.75V2.5C1.25 1.81 1.81 1.25 2.5 1.25C3.19 1.25 3.75 1.81 3.75 2.5V7.75C3.75 8.025 3.525 8.25 3.25 8.25C2.975 8.25 2.75 8.025 2.75 7.75V3H2V7.75C2 8.44 2.56 9 3.25 9C3.94 9 4.5 8.44 4.5 7.75V2.5C4.5 1.395 3.605 0.5 2.5 0.5C1.395 0.5 0.5 1.395 0.5 2.5V8.75C0.5 10.27 1.73 11.5 3.25 11.5C4.77 11.5 6 10.27 6 8.75V3H5.25Z" fill="#6682B4" fill-opacity="0.63"/>
                  </svg> 
                  <ng-container *ngIf="!chat?.pin; else elseTemplate">
                    <button class="pin_btn" mat-icon-button (click)="pinChat($event, chat)">
                      <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.2 1.6V5.6C7.2 6.496 7.496 7.328 8 8H3.2C3.72 7.312 4 6.48 4 5.6V1.6H7.2ZM9.6 0H1.6C1.16 0 0.8 0.36 0.8 0.8C0.8 1.24 1.16 1.6 1.6 1.6H2.4V5.6C2.4 6.928 1.328 8 0 8V9.6H4.776V15.2L5.576 16L6.376 15.2V9.6H11.2V8C9.872 8 8.8 6.928 8.8 5.6V1.6H9.6C10.04 1.6 10.4 1.24 10.4 0.8C10.4 0.36 10.04 0 9.6 0Z" fill="#A3A3A3"/>
                      </svg>
                    </button>
                  </ng-container>
                  <ng-template #elseTemplate>
                    <button mat-icon-button (click)="unPinChat($event, chat)">
                      <!-- <div style="width: 12px; height: 16px; position: relative;">
                      </div> -->
                      <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3" y="1" width="5" height="8" fill="#A3A3A3"/>
                        <path d="M7.2 1.6V5.6C7.2 6.496 7.496 7.328 8 8H3.2C3.72 7.312 4 6.48 4 5.6V1.6H7.2ZM9.6 0H1.6C1.16 0 0.8 0.36 0.8 0.8C0.8 1.24 1.16 1.6 1.6 1.6H2.4V5.6C2.4 6.928 1.328 8 0 8V9.6H4.776V15.2L5.576 16L6.376 15.2V9.6H11.2V8C9.872 8 8.8 6.928 8.8 5.6V1.6H9.6C10.04 1.6 10.4 1.24 10.4 0.8C10.4 0.36 10.04 0 9.6 0Z" fill="#A3A3A3"/>
                      </svg>
                    </button>
                  </ng-template>
                  
                  
              </div>
          </div>
        </div>
      </ng-container>
      <ng-template #elseTemplateDesctopSnippets>
     
        <form [formGroup]="filter" *ngIf="showFilter" class="mob_chats_filter" (ngSubmit)="filterChats(null, null, true)">
          
          <mat-form-field appearance="legacy" class="filter_form status" *ngIf="!useOut">
            <mat-label>{{ "Status" | translate }}</mat-label>
            <mat-select [disableOptionCentering]="true" multiple selectDir formControlName="status_id"  (selectionChange)="selectChange($event)">
            <mat-option *ngFor="let status of statuses" [value]="status.id">
                {{ status.name | translate }}
            </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="d-f-c">
              <div class="d-f-c" *ngIf="!!chats.length">
                  <mat-form-field *ngIf="searchIsOpen" appearance="legacy" class="filter_form search">
                      <mat-label>{{ 'Search' | translate }}</mat-label>
                      <mat-icon matPrefix (click)="filterChats(null, null, true)">search</mat-icon>
                      <input formControlName="q" matInput>
                      <mat-icon (click)="toggleMobSearch();" matSuffix>close</mat-icon>
                  </mat-form-field>
                  <div class="d-f-c icon_mob_filter">
                      <mat-icon *ngIf="!searchIsOpen" matPrefix (click)="toggleMobSearch()">search</mat-icon>
                      <button type="button" mat-icon-button [matMenuTriggerFor]="sortBtn" class="mobActiveFilter" #tooltip="matTooltip" matTooltip="{{ 'Sort' | translate }}" [matTooltipPosition]="'above'">
                        <mat-icon>sort</mat-icon>
                      </button>
                  </div>
              </div>
              
              <mat-menu #sortBtn="matMenu" class="sort_tablet" xPosition='before' overlayPanelClass='sortTAB'>
                <div class="mat-menu-title">{{"Sort By" | translate}}:</div>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="sort(sortValue == 'updated_desc' ? 'updated' : 'updated_desc')" [ngClass]="{'active_status': sortValue == 'updated_desc' || sortValue == 'updated'}">
                    {{  "Updated" | translate }}
                    <div class="d-f-c ml-1">
                        <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('updated_desc')" [ngClass]="{'active': sortValue == 'updated_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                        <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('updated')" [ngClass]="{'active': sortValue == 'updated'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
                    </div>
                </button>
                <button mat-menu-item (click)="sort(sortValue == 'priority_desc' ? 'priority' : 'priority_desc')" [ngClass]="{'active_status': sortValue == 'priority_desc' || sortValue == 'priority'}">
                    {{  "Priority" | translate }}
                    <div class="d-f-c ml-1">
                        <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('priority_desc')" [ngClass]="{'active': sortValue == 'priority_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                        <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('priority')" [ngClass]="{'active': sortValue == 'priority'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
                    </div>
                </button>
                <button mat-menu-item (click)="sort(sortValue == 'id_desc' ? 'id' : 'id_desc')" [ngClass]="{'active_status': sortValue == 'id_desc' || sortValue == 'id'}">
                    {{  "ID" | translate }}
                    <div class="d-f-c ml-1">
                        <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('id_desc')" [ngClass]="{'active': sortValue == 'id_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                        <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('id')" [ngClass]="{'active': sortValue == 'id'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
                    </div>
                </button>
                <button mat-menu-item (click)="sort(sortValue == 'filesize_desc' ? 'filesize' : 'filesize_desc')" [ngClass]="{'active_status': sortValue == 'filesize_desc' || sortValue == 'filesize'}">
                    {{ "Filesize" | translate }}
                    <div class="d-f-c ml-1">
                        <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('filesize_desc')" [ngClass]="{'active': sortValue == 'filesize_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                        <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('filesize')" [ngClass]="{'active': sortValue == 'filesize'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
                    </div>
                </button>
                <button mat-menu-item (click)="sort(sortValue == 'planned_completed_desc' ? 'planned_completed' : 'planned_completed_desc')" [ngClass]="{'active_status': sortValue == 'planned_completed_desc' || sortValue == 'planned_completed'}">
                  {{ "Deadline" | translate }}
                  <div class="d-f-c ml-1">
                      <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('planned_completed_desc')" [ngClass]="{'active': sortValue == 'planned_completed_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                      <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('planned_completed')" [ngClass]="{'active': sortValue == 'planned_completed'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
                  </div>
                </button>
                <button mat-menu-item (click)="sort(sortValue == 'completed_desc' ? 'completed' : 'completed_desc')" [ngClass]="{'active_status': sortValue == 'completed_desc' || sortValue == 'completed'}">
                  {{ "Completed" | translate }}
                  <div class="d-f-c ml-1">
                      <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('completed_desc')" [ngClass]="{'active': sortValue == 'completed_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                      <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('completed')" [ngClass]="{'active': sortValue == 'completed'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
                  </div>
              </button>
              </mat-menu>
          </div>
        </form>
        
        <div class="mob_chat" (click)="useOut ? goToChat(chat) : openChat($event, chat, cInd)" *ngFor="let chat of chats; let cInd = index;" [ngClass]="{'highlight_chat': chat.is_read == '0'}">
          <button mat-icon-button class="mob_vert" [matMenuTriggerFor]="menuChat" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menuChat="matMenu">
            <button mat-menu-item (click)="openNotes(chat)">
              <mat-icon>text_snippet</mat-icon>
              <span>{{ 'Notes' | translate }}</span>
            </button>
            <button mat-menu-item (click)="editChat(chat)">
                <mat-icon>edit</mat-icon> 
                <span>{{ "Edit" | translate }}</span>
            </button>
            <button mat-menu-item (click)="toShortCut($event, chat, 'chat')">
              <div class="d-f-c">
                <svg width="18" style="margin-right: 16px;" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 0L5.778 5.004L0 6.516L3.78 11.142L3.438 17.1L9 14.931L14.562 17.1L14.22 11.142L18 6.516L12.222 5.004L9 0ZM6.642 7.2C7.2 7.2 7.65 7.65 7.65 8.217C7.65 8.48434 7.5438 8.74073 7.35476 8.92976C7.16573 9.1188 6.90934 9.225 6.642 9.225C6.075 9.225 5.625 8.775 5.625 8.217C5.625 7.65 6.075 7.2 6.642 7.2ZM11.367 7.2C11.925 7.2 12.375 7.65 12.375 8.217C12.375 8.48434 12.2688 8.74073 12.0798 8.92976C11.8907 9.1188 11.6343 9.225 11.367 9.225C10.8 9.225 10.35 8.775 10.35 8.217C10.35 7.65 10.8 7.2 11.367 7.2ZM6.3 11.25H11.7C11.25 12.339 10.179 13.05 9 13.05C7.821 13.05 6.75 12.339 6.3 11.25Z" fill="#686868"/>
                </svg>
                <span>{{ "Shortcut" | translate }}</span>
              </div>
            </button>
            <button mat-menu-item (click)="addToBoard(chat)">
                <mat-icon>add</mat-icon> 
                <span>{{ "Add chat to planning board" | translate }}</span>
            </button>
            <button *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin') || company?.permissions.includes('manager') || company?.permissions.includes('assign_task_parameter')" mat-menu-item (click)="openTargetValues([chat.task_id, chat.task_operation_id, chat.id], chat)">
              <mat-icon>settings_suggest</mat-icon> 
              <span>{{ "Tags" | translate }}</span>
            </button>
            <!-- <ng-container *ngIf="company?.permissions.includes('owner')">
                <button mat-menu-item (click)="additionalEmployees(task, work, chat)">
                  <mat-icon>group</mat-icon> 
                  <span>{{ "Additional executor" | translate }}</span>
                </button>
                <button mat-menu-item (click)="addAdditionalEmplToWork(task, work, chat)">
                  <mat-icon>person_add</mat-icon> 
                  <span>{{ "Appoint an additional executor" | translate }}</span>
                </button>
            </ng-container> -->
            <ng-container *ngIf="company?.permissions.includes('owner') || company?.permissions?.includes('admin'); else elseTemplateOwnerDel">
                <button mat-menu-item (click)="deleteChat(chat)">
                    <mat-icon>delete</mat-icon>
                    <span>{{ "Delete" | translate }}</span>
                </button>
            </ng-container>
            <ng-template #elseTemplateOwnerDel>
                <div
                matTooltip="{{ 'You do not have access for this action.' | translate }}"
                [matTooltipPosition]="'left'">
                    <button mat-menu-item disabled>
                        <mat-icon>delete</mat-icon>
                        <span>{{ "Delete" | translate }}</span>
                    </button>
                </div>
            </ng-template>
            <button *ngIf="(company?.permissions.includes('owner') || company?.permissions.includes('manager')) && chat?.company_id == company.id" mat-menu-item (click)="moveChat(chat)">
              <mat-icon style="transform: rotate(45deg);">zoom_out_map</mat-icon> 
              <span>{{ "Move chat to other job" | translate }}</span>
            </button>
          </mat-menu>
          <div class="chat_photo">
            <ng-container *ngIf="chat?.lastPost?.action; else elseTemplateHasActionPhoto">
                <ng-container *ngIf="!!chat?.lastPost?.action?.createdEmployee?.image; else elseOwnerTemplateLastPostPhoto">
                    <img [appHoverUserInfo]="{ user: chat?.lastPost?.action?.createdEmployee, company_id: company?.id }" [src]="chat?.lastPost?.action?.createdEmployee?.image" alt="">
                </ng-container>
                <ng-template #elseOwnerTemplateLastPostPhoto>
                    <mat-icon [appHoverUserInfo]="{ user: chat?.lastPost?.action?.createdEmployee, company_id: company?.id }">account_circle</mat-icon>
                </ng-template>
            </ng-container>
            <ng-template #elseTemplateHasActionPhoto>
                <ng-container *ngIf="!!chat?.lastPost?.employee?.image; else elseOwnerTemplateLastPostPhoto">
                    <img [appHoverUserInfo]="{ user: chat?.lastPost?.employee, company_id: company?.id }" [src]="chat?.lastPost?.employee?.image" alt="">
                </ng-container>
                <ng-template #elseOwnerTemplateLastPostPhoto>
                    <mat-icon [appHoverUserInfo]="{ user: chat?.lastPost?.employee, company_id: company?.id }">account_circle</mat-icon>
                </ng-template>
            </ng-template>
          </div>
          <div class="chat_data">
              <div class="chat_head">
                  <ng-container *ngIf="chat?.lastPost?.action; else elseTemplateHasActionName">
                      <div class="user_name">{{ chat?.lastPost?.action?.createdEmployee?.name }}</div>
                  </ng-container>
                  <ng-template #elseTemplateHasActionName>
                      <div class="user_name">{{ chat?.lastPost?.employee?.name }}</div>
                  </ng-template>
  
                  <div class="d-f-c">
                      <div class="inside_job" [ngClass]="{
                          'first': chat?.status_id == '1',
                          'second': chat?.status_id == '2',
                          'third': chat?.status_id == '3',
                          'fours': chat?.status_id == '4',
                          'fives': chat?.status_id == '5',
                          'sixs': chat?.status_id == '6',
                          'nine': chat?.status_id == '97',
                          'seven': chat?.status_id == '98',
                          'eight': chat?.status_id == '99'}">
                          <span class="text_one_line">{{ getOperationStatusName(chat?.status_id) | translate }}</span>  
                      </div>
  
                      <div class="date">
                          {{ chat?.lastPost?.updated_at | reportsDate:activeLang }} 
                      </div>
                  </div>
              </div>
              <div class="chat_name text_one_line">
                  {{ chat?.name }}
              </div>
  
              <ng-container *ngIf="chat?.lastPost?.action; else elseTemplateHasAction">
                <div class="chat_last_post">           
                  {{ 'switched to' | translate }} 
                  <ng-container [ngSwitch]="chat?.lastPost?.action?.action">
                    <ng-container *ngSwitchCase="'task_employee_status_change'">
                      <b style="margin-left: 5px; margin-right: 5px;">{{ getOperationStatusName(chat?.lastPost?.action?.task_employee_status_id) }}</b>
                      {{ "for" | translate }}
                      <ng-container *ngIf="!!chat?.lastPost?.action?.employee?.image; else elseActionOwnerTemplate">
                          <img [appHoverUserInfo]="{ user: chat?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5" [src]="chat?.lastPost?.action?.employee?.image" alt="">
                      </ng-container>
                      <ng-template #elseActionOwnerTemplate>
                          <mat-icon [appHoverUserInfo]="{ user: chat?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5">account_circle</mat-icon>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngSwitchCase="'discussion_status'">
                      <b style="margin-left: 5px;">{{ getOperationStatusName(chat?.lastPost?.action?.discussion_status_id) }}</b>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
  
              <ng-template #elseTemplateHasAction>
                  <div class="chat_last_post">
                      <div class="last_post_file" *ngIf="!!chat?.lastPost?.file_id">
                      <div class="file_view">
                          <ng-container [ngSwitch]="understandFileType(chat?.lastPost?.file?.content_type)">
                              <ng-container *ngSwitchCase="'video'">
                                  <div class="file movie d-f-c">
                                      <ng-container *ngIf="chat?.lastPost?.file?.thumbnail; else elseTemplateThumbnail">
                                          <div class="movie_thumb" >
                                              <img style="max-width: 100%; max-height: 100%;" (error)="onImgError($event)" [src]="host + chat?.lastPost?.file?.thumbnail + '?company_id=' + company?.id">
                                          </div>
                                      </ng-container>
                                      <ng-template #elseTemplateThumbnail>
                                          <mat-icon class="file_img_icon" style="color: #3f51b5">
                                              movie
                                          </mat-icon>
                                      </ng-template>
                                  </div>
                              </ng-container>
                              <ng-container *ngSwitchCase="'pdf'">
                                <div class="pdf">
                                    <svg height="800px" width="800px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                        viewBox="0 0 303.188 303.188" xml:space="preserve">
                                        <g>
                                            <polygon style="fill:#E8E8E8;" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 	"/>
                                            <path style="fill:#FB3449;" d="M230.013,149.935c-3.643-6.493-16.231-8.533-22.006-9.451c-4.552-0.724-9.199-0.94-13.803-0.936
                                                c-3.615-0.024-7.177,0.154-10.693,0.354c-1.296,0.087-2.579,0.199-3.861,0.31c-1.314-1.36-2.584-2.765-3.813-4.202
                                                c-7.82-9.257-14.134-19.755-19.279-30.664c1.366-5.271,2.459-10.772,3.119-16.485c1.205-10.427,1.619-22.31-2.288-32.251
                                                c-1.349-3.431-4.946-7.608-9.096-5.528c-4.771,2.392-6.113,9.169-6.502,13.973c-0.313,3.883-0.094,7.776,0.558,11.594
                                                c0.664,3.844,1.733,7.494,2.897,11.139c1.086,3.342,2.283,6.658,3.588,9.943c-0.828,2.586-1.707,5.127-2.63,7.603
                                                c-2.152,5.643-4.479,11.004-6.717,16.161c-1.18,2.557-2.335,5.06-3.465,7.507c-3.576,7.855-7.458,15.566-11.815,23.02
                                                c-10.163,3.585-19.283,7.741-26.857,12.625c-4.063,2.625-7.652,5.476-10.641,8.603c-2.822,2.952-5.69,6.783-5.941,11.024
                                                c-0.141,2.394,0.807,4.717,2.768,6.137c2.697,2.015,6.271,1.881,9.4,1.225c10.25-2.15,18.121-10.961,24.824-18.387
                                                c4.617-5.115,9.872-11.61,15.369-19.465c0.012-0.018,0.024-0.036,0.037-0.054c9.428-2.923,19.689-5.391,30.579-7.205
                                                c4.975-0.825,10.082-1.5,15.291-1.974c3.663,3.431,7.621,6.555,11.939,9.164c3.363,2.069,6.94,3.816,10.684,5.119
                                                c3.786,1.237,7.595,2.247,11.528,2.886c1.986,0.284,4.017,0.413,6.092,0.335c4.631-0.175,11.278-1.951,11.714-7.57
                                                C231.127,152.765,230.756,151.257,230.013,149.935z M119.144,160.245c-2.169,3.36-4.261,6.382-6.232,9.041
                                                c-4.827,6.568-10.34,14.369-18.322,17.286c-1.516,0.554-3.512,1.126-5.616,1.002c-1.874-0.11-3.722-0.937-3.637-3.065
                                                c0.042-1.114,0.587-2.535,1.423-3.931c0.915-1.531,2.048-2.935,3.275-4.226c2.629-2.762,5.953-5.439,9.777-7.918
                                                c5.865-3.805,12.867-7.23,20.672-10.286C120.035,158.858,119.587,159.564,119.144,160.245z M146.366,75.985
                                                c-0.602-3.514-0.693-7.077-0.323-10.503c0.184-1.713,0.533-3.385,1.038-4.952c0.428-1.33,1.352-4.576,2.826-4.993
                                                c2.43-0.688,3.177,4.529,3.452,6.005c1.566,8.396,0.186,17.733-1.693,25.969c-0.299,1.31-0.632,2.599-0.973,3.883
                                                c-0.582-1.601-1.137-3.207-1.648-4.821C147.945,83.048,146.939,79.482,146.366,75.985z M163.049,142.265
                                                c-9.13,1.48-17.815,3.419-25.979,5.708c0.983-0.275,5.475-8.788,6.477-10.555c4.721-8.315,8.583-17.042,11.358-26.197
                                                c4.9,9.691,10.847,18.962,18.153,27.214c0.673,0.749,1.357,1.489,2.053,2.22C171.017,141.096,166.988,141.633,163.049,142.265z
                                                M224.793,153.959c-0.334,1.805-4.189,2.837-5.988,3.121c-5.316,0.836-10.94,0.167-16.028-1.542
                                                c-3.491-1.172-6.858-2.768-10.057-4.688c-3.18-1.921-6.155-4.181-8.936-6.673c3.429-0.206,6.9-0.341,10.388-0.275
                                                c3.488,0.035,7.003,0.211,10.475,0.664c6.511,0.726,13.807,2.961,18.932,7.186C224.588,152.585,224.91,153.321,224.793,153.959z"/>
                                            <polygon style="fill:#FB3449;" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0 	"/>
                                            <g>
                                                <path style="fill:#A4A9AD;" d="M126.841,241.152c0,5.361-1.58,9.501-4.742,12.421c-3.162,2.921-7.652,4.381-13.472,4.381h-3.643
                                                    v15.917H92.022v-47.979h16.606c6.06,0,10.611,1.324,13.652,3.971C125.321,232.51,126.841,236.273,126.841,241.152z
                                                    M104.985,247.387h2.363c1.947,0,3.495-0.546,4.644-1.641c1.149-1.094,1.723-2.604,1.723-4.529c0-3.238-1.794-4.857-5.382-4.857
                                                    h-3.348C104.985,236.36,104.985,247.387,104.985,247.387z"/>
                                                <path style="fill:#A4A9AD;" d="M175.215,248.864c0,8.007-2.205,14.177-6.613,18.509s-10.606,6.498-18.591,6.498h-15.523v-47.979
                                                    h16.606c7.701,0,13.646,1.969,17.836,5.907C173.119,235.737,175.215,241.426,175.215,248.864z M161.76,249.324
                                                    c0-4.398-0.87-7.657-2.609-9.78c-1.739-2.122-4.381-3.183-7.926-3.183h-3.773v26.877h2.888c3.939,0,6.826-1.143,8.664-3.43
                                                    C160.841,257.523,161.76,254.028,161.76,249.324z"/>
                                                <path style="fill:#A4A9AD;" d="M196.579,273.871h-12.766v-47.979h28.355v10.403h-15.589v9.156h14.374v10.403h-14.374
                                                    L196.579,273.871L196.579,273.871z"/>
                                            </g>
                                            <polygon style="fill:#D1D3D3;" points="219.821,50.525 270.346,50.525 219.821,0 	"/>
                                        </g>
                                    </svg>
                                </div>
                            </ng-container>
                              <ng-container *ngSwitchCase="'image'">
                                  <div class="img_wrp">
                                      <img (error)="onImgError($event)" [src]="host + (chat?.lastPost?.file?.thumbnail ? chat?.lastPost?.file?.thumbnail + '?company_id=' + company?.id : chat?.lastPost?.file?.original + '?company_id=' + company?.id)" alt="">
                                  </div>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                              <ng-container *ngIf="!!chat?.lastPost?.file?.thumbnail; else elseTemplateHasThumb">
                                  <div class="img_wrp">
                                  <img (error)="onImgError($event)" [src]="host + chat?.lastPost?.file?.thumbnail + '?company_id=' + company?.id" alt="">
                                  </div>
                              </ng-container>
                              <ng-template #elseTemplateHasThumb>
                                  <div class="file d-f-c">
                                  <mat-icon class="file_img_icon mr-1" style="color: #3f51b5">
                                      insert_drive_file
                                  </mat-icon>
                              </div>
                              </ng-template>
                              </ng-container>
                          </ng-container>
                      </div>
                      <!-- <div class="file_info">
                          <span class="file_name">{{ chat?.lastPost?.file?.filename }}</span>
                          <span class="file_size">{{ chat?.lastPost?.file?.filesize | filesize }}</span>
                      </div> -->
  
                      </div>
                      
                      <div class="text_one_line" [innerHTML]='chat?.lastPost?.text ? (chat?.lastPost?.text.replaceAll("\n"," ").replaceAll("</BR>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("<br>"," ")) : ""'></div>
                  </div>
            </ng-template>
            <div class="chat_footer">
              <div class="foot_line">
                <div class="job_type">
                    {{ getColumnName(chat?.taskOperation?.operation_id) }}
                </div>
                <div class="job_desc text_one_line" *ngIf="chat?.taskOperation?.name">
                    {{ chat?.taskOperation?.name }}
                </div>
              </div>
              <div class="foot_line">
                <div class="group">
                    <span class="text_one_line" *ngIf="chat?.task?.group_id">
                      {{ getGroup(chat?.task?.group_id).name }}
                    </span>
                </div>
                <div class="task text_one_line">
                  {{ chat?.task?.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      

    </div>
    <!-- <app-loader-more *ngIf="isLoad"></app-loader-more> -->
    <!-- isLoad - {{isLoad}} -->
    <mat-progress-bar mode="indeterminate" *ngIf="isLoad" class="mat_proggress_w8"></mat-progress-bar>
</div>

<ng-template #filterMenu let-val>
  <section class="search_params">
    <form [formGroup]="filter" class="params_form" (ngSubmit)="filterChats(null, null, true)" >
      <mat-form-field class="search-field" appearance="legacy">
        <mat-label>{{ "Chat title" | translate }}</mat-label>
        <input matInput formControlName="q_name">
      </mat-form-field>
      <mat-form-field class="search-field" appearance="legacy">
        <mat-label>{{ "Chat messages" | translate }}</mat-label>
        <input matInput formControlName="q_text">
      </mat-form-field>

      <div class="d-f-c" style="padding-top: 20px; justify-content: flex-end;">
        
        <button mat-button type="button" (click)="closeOpenFilter()">{{ "Close" | translate }}</button>
        <button mat-raised-button color="primary" type="submit" class="ml-1">{{ "Search" | translate }}</button>
      </div>
    </form>
  </section>
</ng-template>


  <!-- Date filters -->
  <ng-template #chatFilterDateMenu let-val>
    <section class="chats_data_filter">
      <mat-tab-group mat-align-tabs="center" class="create_new_task_tabs">
        <mat-tab>
            <ng-template mat-tab-label>
              {{ "Chat Date" | translate }}
            </ng-template>

            <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterChats()">
                <mat-calendar (selectedChange)="rangeChange($event, 'created_at_', 'createdDateRange')" [selected]="createdDateRange"></mat-calendar>
                <div class="apply_date">
                    <button mat-raised-button class="ml-1" color="primary" type="submit" (click)="closeDateFilter(); filterChats();">{{ "Apply" | translate }}</button>
                </div>
            </form>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            {{ "Post Date" | translate }}*
          </ng-template>

          <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterChats()">
            <mat-calendar (selectedChange)="rangeChange($event, 'posted_at_', 'postsDateRange')" [selected]="postsDateRange"></mat-calendar>
            <div class="apply_date">
                <button mat-raised-button class="ml-1" color="primary" type="submit" (click)="closeDateFilter(); filterChats();">{{ "Apply" | translate }}</button>
            </div>
          </form>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            {{ "Chat completed" | translate }}*
          </ng-template>

          <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterChats()">
            <mat-calendar (selectedChange)="rangeChange($event, 'discussion_completed_at_', 'completedDateRange')" [selected]="completedDateRange"></mat-calendar>
            <div class="apply_date">
                <button mat-raised-button class="ml-1" color="primary" type="submit" (click)="closeDateFilter(); filterChats();">{{ "Apply" | translate }}</button>
            </div>
          </form>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            {{ "Deadline" | translate }}*
          </ng-template>

          <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterChats()">
            <mat-calendar (selectedChange)="rangeChange($event, 'discussion_planned_completed_at_', 'deadlineDateRange')" [selected]="deadlineDateRange"></mat-calendar>
            <div class="apply_date">
                <button mat-raised-button class="ml-1" color="primary" type="submit" (click)="closeDateFilter(); filterChats();">{{ "Apply" | translate }}</button>
            </div>
          </form>
        </mat-tab>
      </mat-tab-group>
    </section>
  </ng-template>

    <!-- Tags filter -->
    <ng-template #filterParameterMenu let-val>
      <section class="task_executor_filter">
        <mat-tab-group mat-align-tabs="center" class="create_new_task_tabs">
          <mat-tab>
              <ng-template mat-tab-label>
                  {{ "For Chat" | translate }}
              </ng-template>
  
              <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">
                <ng-container *ngFor="let param of parameters">
                  <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!param?.hasValues">
                      <mat-label>{{ param.name }}</mat-label>
          
                      <mat-chip-list 
                          class="without_ordered"
                          #paramsChipList
                          formControlName="discussion_parameter_value_id"
                      >
                          <mat-chip 
                              class="param_chip_on_page"
                              *ngFor="let val of param.activeTaskValues; let k = index;"
                              [removable]="true" 
                              color="primary" 
                              (removed)="onRemove(val, param, 'discussion_parameter_value_id')">
                                  {{ getValueById(val.id)?.value }} <span class="parameter_name" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span>
                              <mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip>
          
                          <input
                          id="param_input_{{param.id}}"
                          class="auto_complete_input"
                          placeholder="{{ 'Search' | translate }}"
                          #paramsInput
                          [formControl]="param.search"
                          [matAutocomplete]="paramsAuto"
                          [matChipInputFor]="paramsChipList"
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          (matChipInputTokenEnd)="add($event)">
                      </mat-chip-list>
                      <mat-autocomplete class="filter_autocomlete" autoActiveFirstOption #paramsAuto="matAutocomplete" (optionsScroll)="onScrollParams(param)" (optionSelected)="selected($event, param, 'discussion_parameter_value_id')">
                          <ng-container *ngFor="let val of param.values">
                              <mat-option *ngIf="noOption(param.activeTaskValues, val.id) && withSearch(param?.search?.value, val)" [value]="val">
                                  {{ val.value }}
                              </mat-option>
                          </ng-container>
                      </mat-autocomplete>
                  </mat-form-field>
                </ng-container>
              </form>
          </mat-tab>
          <mat-tab>
              <ng-template mat-tab-label>
                  {{ "For all" | translate }}
              </ng-template>
  
              <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">
                <ng-container *ngFor="let param of parameters">
  
                  <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!param?.hasValues">
                      <mat-label>{{ param.name }}</mat-label>
          
                      <mat-chip-list 
                          class="without_ordered"
                          #paramsChipList
                          formControlName="parameter_value_id"
                      >
                          <mat-chip 
                              class="param_chip_on_page"
                              *ngFor="let val of param.activeValues; let k = index;"
                              [removable]="true" 
                              color="primary" 
                              (removed)="onRemove(val, param, 'parameter_value_id')">
                                  {{ getValueById(val.id)?.value }} <span class="parameter_name" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span>
                              <mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip>
          
                          <input
                          id="all_param_input_{{param.id}}"
                          class="auto_complete_input"
                          placeholder="{{ 'Search' | translate }}"
                          #paramsInput
                          [formControl]="param.search"
                          [matAutocomplete]="paramsAuto"
                          [matChipInputFor]="paramsChipList"
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          (matChipInputTokenEnd)="add($event)">
                      </mat-chip-list>
                      <mat-autocomplete class="filter_autocomlete" autoActiveFirstOption #paramsAuto="matAutocomplete" (optionsScroll)="onScrollParams(param)" (optionSelected)="selected($event, param, 'parameter_value_id')">
                          <ng-container *ngFor="let val of param.values">
                              <mat-option *ngIf="noOption(param.activeValues, val.id) && withSearch(param?.search?.value, val)" [value]="val">
                                  {{ val.value }}
                              </mat-option>
                          </ng-container>
                      </mat-autocomplete>
                  </mat-form-field>
                </ng-container>
              </form>
          </mat-tab>
        </mat-tab-group>
      </section>
  </ng-template>


  <ng-template #chatMenu let-menuData>
    <section class="proj-file-menu">
          <div (click)="addToBoard(menuData?.chat); closeChatMenu();">
              <svg class="mr-1" style="width: 18px; height: 18px" width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.8 12L6 16.8H9.6V24H12V16.8H15.6L10.8 12ZM19.2 2.4H18V0H15.6V2.4H6V0H3.6V2.4H2.4C1.76348 2.4 1.15303 2.65286 0.702944 3.10294C0.252856 3.55303 0 4.16348 0 4.8V21.6C0 22.2365 0.252856 22.847 0.702944 23.2971C1.15303 23.7471 1.76348 24 2.4 24H7.2V21.6H2.4V8.4H19.2V21.6H14.4V24H19.2C19.8365 24 20.447 23.7471 20.8971 23.2971C21.3471 22.847 21.6 22.2365 21.6 21.6V4.8C21.6 4.16348 21.3471 3.55303 20.8971 3.10294C20.447 2.65286 19.8365 2.4 19.2 2.4Z" fill="#219653"/>
              </svg>
              {{ 'Add to board' | translate }}
          </div>
          
          <div ngxClipboard [cbContent]="origin + '/chat/' + menuData?.chat?.acm" (cbOnSuccess)="copyLink('chat'); closeChatMenu();">
              <mat-icon class="mr-1">link</mat-icon> 
              {{ 'Copy url to chat' | translate }}
          </div>

          <div (click)="openTargetValues([menuData?.chat?.task_id, menuData?.chat?.task_operation_id, menuData?.chat?.id], menuData?.chat)">
            <svg class="mr-1" width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 18px; height: 15px;"><path d="M3.15 4.5C3.50804 4.5 3.85142 4.35777 4.10459 4.10459C4.35777 3.85142 4.5 3.50804 4.5 3.15C4.5 2.79196 4.35777 2.44858 4.10459 2.19541C3.85142 1.94223 3.50804 1.8 3.15 1.8C2.79196 1.8 2.44858 1.94223 2.19541 2.19541C1.94223 2.44858 1.8 2.79196 1.8 3.15C1.8 3.50804 1.94223 3.85142 2.19541 4.10459C2.44858 4.35777 2.79196 4.5 3.15 4.5ZM13.869 6.822C14.193 7.146 14.4 7.596 14.4 8.1C14.4 8.595 14.202 9.045 13.869 9.369L9.369 13.869C9.045 14.193 8.595 14.4 8.1 14.4C7.605 14.4 7.155 14.202 6.822 13.869L0.531 7.578C0.198 7.245 0 6.795 0 6.3V1.8C0 0.801 0.801 0 1.8 0H6.3C6.795 0 7.245 0.198 7.569 0.522L13.869 6.822ZM10.386 1.539L11.286 0.639L17.469 6.822C17.802 7.146 18 7.605 18 8.1C18 8.595 17.802 9.045 17.478 9.369L12.636 14.211L11.736 13.311L16.875 8.1L10.386 1.539Z" fill="#686868"></path></svg>
            {{ "Tags" | translate }}
          </div>
  
          <a [href]="origin + '/chat/' + menuData?.chat?.acm" (click)="openInNew($event, menuData?.chat); closeChatMenu();">
              <mat-icon class="mr-1">open_in_new</mat-icon>
              {{ 'Open in new tab' | translate }}
          </a>
  
          <div (click)="toPersonalStatuses(menuData?.chat); closeChatMenu();">
              <mat-icon class="mr-1">manage_accounts</mat-icon> 
              {{ 'Statuses' | translate }}
          </div>
    </section>
  </ng-template>